/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Parameters Creation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './parametersCreationView';

export const mapStateToPropsParamCreation = mapStateToProps;
export const mapDispatchToPropsParamCreation = mapDispatchToProps;

export default connect(
  mapStateToPropsParamCreation,
  mapDispatchToPropsParamCreation
)(View);
